import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { CreateCampaignComponent } from '../../../../molecules/create-campaign/create-campaign.component';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { ImageService } from '../../../../services/image/image.service';
import { CreateBriefService } from '../../../briefs/service/create-brief/create-brief.service';
import { BbField } from '../../ui/bb-field/bb-field';
import { BbStepper } from '../../ui/bb-stepper/bb-stepper';
import { BbOptionCard } from '../../ui/bb-option-card/bb-option-card';
import { BRIEF_BUILDER_GOALS, BriefBuilderGoal } from '../../brief-builder.constants';
import { BriefBasicsCampaignStore } from './brief-basics-campaign.store';
import {
  BRIEF_BASICS_BRAND_CONTEXT,
  BRIEF_BASICS_CAMPAIGN_API,
  BRIEF_BASICS_CAMPAIGN_HOST,
} from './brief-basics-campaign.tokens';

/** Brief basics: title, campaign, campaign goal, volume. */
@Component({
  selector: 'bb-brief-basics-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BbField, BbStepper, BbOptionCard, CreateCampaignComponent],
  providers: [
    BriefBasicsCampaignStore,
    { provide: BRIEF_BASICS_CAMPAIGN_HOST, useExisting: CreateBriefService },
    { provide: BRIEF_BASICS_CAMPAIGN_API, useExisting: CampaignService },
    { provide: BRIEF_BASICS_BRAND_CONTEXT, useExisting: CurrentUserService },
  ],
  templateUrl: './brief-basics-section.html',
  styleUrls: ['./brief-basics-section.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BriefBasicsSection implements OnInit {
  readonly service = inject(CreateBriefService);
  readonly imageService = inject(ImageService);
  readonly campaignStore = inject(BriefBasicsCampaignStore);
  readonly goals: BriefBuilderGoal[] = BRIEF_BUILDER_GOALS;
  readonly creatorCounts = [5, 10, 25, 50];

  ngOnInit(): void {
    this.campaignStore.loadCampaigns();
  }

  setTitle(value: string): void {
    this.service.basicInfoModel.set({ briefTitle: value });
  }

  pickCreatorCount(count: number): void {
    this.service.requiredCreators.set(count);
  }

  creatorCountClass(count: number): string {
    const variant = this.service.requiredCreators() === count ? 'btn-shout-primary' : 'btn-shout-secondary';
    return `btn-shout btn-shout-sm ${variant}`;
  }

  selectGoal(goal: BriefBuilderGoal): void {
    this.service.selectedBriefGoal.set({
      id: goal.id,
      name: goal.name,
      description: goal.description,
      color: goal.color,
    });
  }
}
